<p-dialog
  [header]="'Error'"
  [visible]="showApiError()"
  [modal]="true"
  [draggable]="false"
  [focusOnShow]="false"
  (visibleChange)="showApiError.set(false)"
  (onHide)="apiStore.errorConfirmCallback() ? apiStore.errorConfirmCallback()!() : apiStore.clearError()"
>
  <rr-ui-core-error
    [errorRequests]="{
      mainActionlabel: 'Go back to Home',
      hideMainAction: true,
      hideErrorIcon: true,
      showLogout: false,
      errorDescription: errorMessages(),
      hasTheme: true,
      showSubMessage: true,
    }"
  />
  @if (apiStore.errorConfirmCallback()) {
    <ng-template #footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <p-button
          type="button"
          class="error-callback-btn"
          label="OK"
          (onClick)="apiStore.errorConfirmCallback()!()"
        ></p-button>
      </div>
    </ng-template>
  }
</p-dialog>
